
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/date_input/templates/single"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='calendarIcon'></div>\n<div class=\"datepickerContainer\"></div>\n<input class='value' type='hidden'>";
},"useData":true});
    }).call(this);
  